import {StoreDevtoolsModule} from "@ngrx/store-devtools";

export const storeDevToolsImport = [
  StoreDevtoolsModule.instrument({
    maxAge: 25
  })
];
